import React from 'react';
import './About.css';
import DownloadPDFButton from './DownloadPDFButton';
import maxCatImage from "../assets/max_cat.png";
import buckyImage from "../assets/moser.png";
import mutantImage from "../assets/mutant_c60.png";
import rolloutImage from "../assets/rollout.png";
import GRImage from "../assets/gr.jpg";


const About = () => {
  return (
    <div className="about-page">
    <DownloadPDFButton />
      {/* Main Content */}
      <div className="content-container">

                  {/* What is Tangled */}
        <section className="content-section">
          <div className="section-content">
            <h2>What is Tangled?</h2>
            <p>
              Tangled is a graph coloring game where players take turns strategically coloring edges.
                It can be played on any connected graph, like the one to the right.
                The game was designed to be easy to play, hard to play well for any classical
                agent (including people!), but learnable for agents with access to
                quantum computers. You can play against quantum agents here and try to beat them!
            </p>
          </div>
          <div className="section-image">
            {/* Placeholder for game board image */}
              <img
            src={buckyImage}
            alt="BuckyBall Graph"
            className="bucky-image"
          />
          </div>

        </section>

        {/* History */}
        <section className="content-section">
          <div className="section-content">
            <h2>A Tangled History</h2>
            <p>
              The idea behind Tangled is simple: Make anything quantum computers happen to be good at, no
                matter how exotic, the <em>reward</em> (in the reinforcement learning sense) associated with winning
                or losing a game. In this setting, agents trained using quantum computers should not only be superhuman
                but <em>superclassical</em> (categorically better than any agent without access to QC). In 2012 I designed
                and implemented a game of this kind called Max-Cat (a play on MAX-SAT, the problem the game
                was built around). Max-Cat is fun, but it wasn't designed to work in the quantum
                advantage regime. I decided to implement Tangled because I wanted to see if I could train the world's first
                superclassical agent.
            </p>
          </div>
          <div className="section-image">
                        <img
            src={maxCatImage}
            alt="Max-Cat"
            className="maxcat-image"
          />
          </div>
        </section>


        {/* Quantum AI */}
        <section className="content-section">
          <div className="section-content">
            <h2>Quantum Agents</h2>
            <p>
              The AI opponents in Tangled you can play against here are of three types. The first is a random agent
                that just makes random moves. Not a great strategy, but good to play against when you are learning.
                The second is an agent using pure Monte Carlo Tree Search (MCTS). This is a
                game playing algorithm that uses planning during game play to select moves. The third and most powerful
                are agents that use the AlphaZero approach, which combines MCTS with a neural net that learns from
                experience to play well. Both MCTS and AlphaZero agents on this site use and/or were trained using a
                real quantum computer that evaluates the scores of completed games. In this sense they are 'quantum
                agents', and a new kind of intelligence.
            </p>
          </div>
                      <div className="section-image">
                        <img
            src={rolloutImage}
            alt="Ai Avatar"
            className="rollout-image"
          />
                      </div>
        </section>

        {/* Why It Matters */}
        <section className="content-section">

          <div className="section-content">
            <h2>What The Point of This Is</h2>
            <p>
              I am very interested in the intersection of superintelligence and theoretical physics. I think
              it's necessary for superintelligences to have access
              to quantum computation for them to be able to properly explore and learn about our Universe. This
              project is a first step along that path. By playing against these agents, you are seeing the first
              glimpses of a new kind of <em>superclassical </em> intelligence that should, for certain things, be
              categorically better than any agent without access to quantum computation (which presumably includes
              all possible biological intelligences). The game itself is not very fun to play, but it wasn't designed
              with that in mind. It was designed to test whether superclassical agents can be built with today's
              quantum computing technology.
            </p>
          </div>

                      <div className="section-image">
                        <img
            src={mutantImage}
            alt="Mutant C60"
            className="maxcat-image"
          />
          </div>

        </section>


        {/* Who is Responsible */}
        <section className="content-section">
          <div className="section-content">
            <h2>Who Built This?</h2>
            <p>
                I did! My name is <a href={"https://www.geordierose.com"}>Geordie Rose</a>. Tangled is a
                project I started in September of 2024.
            </p>
          </div>
          <div className="section-image">
            {/* Placeholder for game board image */}
              <img
            src={GRImage}
            alt="Geordie Rose"
            className="gr-image"
          />
          </div>

        </section>

      </div>
    </div>
  );
};

export default About;